import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { callCreateApiTokenRequest } from '../requests/CreateScimConfigApiTokenRequest';
import { callCreateScimConfigRequest } from '../requests/CreateScimConfigRequest';
import { callGetScimConfigRequest } from '../requests/GetScimConfigRequest';
import { callUpdateScimConfigRequest } from '../requests/UpdateScimConfigRequest';

export interface IScimConfig {
  id?: string;
  mode?: string;
  siteIds?: string[];
  isEnabled?: boolean;
  createdAt?: string;
  apiTokenId?: string;
  updatedAt?: string;
  authentication?: string;
  authenticationId?: string;
}

export interface ICreateScimConfigResponse extends IResult {
  createServerScimConfigResponse: IScimConfig;
}

export interface IUpdateScimConfigResponse extends IResult {
  createServerScimConfigResponseForUpdate: IScimConfig;
}

export interface ApiTokenResponse extends IResult {
  apiToken: {
    clientName?: string;
    id?: string;
    scope?: string;
    secret?: string;
  };
}

export interface ICreateScimConfigRequest {
  createServerScimConfigRequest: {
    mode: string;
    siteId: string[];
  };
}

export interface IUpdateScimConfigRequest {
  createServerScimConfigRequestForUpdate: {
    isEnabled?: boolean;
    authentication?: string;
    authenticationId?: string;
  };
}

export namespace ScimConfigService {

  export function createScimConfig(scimConfig: IScimConfig): Promise<IScimConfig> {
    return callCreateScimConfigRequest(scimConfig)
      .then((result: ICreateScimConfigResponse) => {
        return result.createServerScimConfigResponse;
      })
      .catch((error) => {
        throw error;
      });
  }

  export function updateScimConfig(scimConfig: IScimConfig): Promise<IScimConfig> {
    return callUpdateScimConfigRequest(scimConfig)
      .then((result: IUpdateScimConfigResponse) => {
        return result.createServerScimConfigResponseForUpdate;
      })
      .catch((error) => {
        throw error;
      });
  }

  export function createApiToken(scimConfigId: string): Promise<string> {
    return callCreateApiTokenRequest(scimConfigId)
      .then((result: ApiTokenResponse) => {
        return result.apiToken.secret;
      })
      .catch((error) => {
        throw error;
      });
  }

  export function getScimConfig(): Promise<IScimConfig> {
    return callGetScimConfigRequest()
      .then((result: ICreateScimConfigResponse) => {
        return result.createServerScimConfigResponse;
      })
      .catch((error) => {
        throw error;
      });
  }
}